import Vue from "vue";
import Vuex from "vuex";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { state, StateRoot } from "./state";

Vue.use(Vuex);

export const options = {
  state,
  mutations,
  actions,
};

export default new Vuex.Store<StateRoot>(options);
